import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {DataService} from '../../../Services/data.service';
import {StorageService} from '../../../Services/storage.service';
import {Title} from '@angular/platform-browser';
import {BsToastService} from '../../../Services/bs-toast-service';

@Component({
  selector: 'app-crm-opportunities',
  templateUrl: './crm-opportunities.component.html',
  styleUrls: ['./crm-opportunities.component.css'],
  standalone: false
})
export class CrmOpportunitiesComponent implements OnInit {

  isLoading = true;
  opportunities: any[] = [];
  totalRecords = 0;
  page = 0;
  pageSize = 25;

  filterStatus = 'open';
  filterType = '';

  tableColumns = [
    {key: 'title', label: 'Title', sortable: true},
    {key: 'entity_name', label: 'Entity', sortable: true},
    {key: 'stage_name', label: 'Stage', sortable: true},
    {key: 'opportunity_type', label: 'Type', sortable: true},
    {key: 'salesperson_name', label: 'Salesperson', sortable: true},
    {key: 'estimated_value', label: 'Est. Value', sortable: true},
    {key: 'probability', label: 'Probability', sortable: true},
    {key: 'expected_close_date', label: 'Expected Close', sortable: true},
    {key: 'status', label: 'Status', sortable: true},
    {key: 'actions', label: '', sortable: false},
  ];

  // Log Interaction modal
  logInteractionForId: string | null = null;
  activeEntityId: string | null = null;
  activeCompanyId: string | null = null;

  constructor(
    private dataService: DataService,
    private localStorage: StorageService,
    private titleService: Title,
    private notification: BsToastService,
    private router: Router
  ) {
  }

  ngOnInit(): void {
    this.titleService.setTitle('CRM Opportunities');
    this.loadOpportunities();
  }

  loadOpportunities(): void {
    this.isLoading = true;
    const companyId = this.localStorage.StorageGet('default_company_id', '');
    let params = '?page=' + this.page + '&pageSize=' + this.pageSize;
    if (companyId) {
      params += '&company_id=' + encodeURIComponent(companyId);
    }
    if (this.filterStatus) {
      params += '&status=' + encodeURIComponent(this.filterStatus);
    }
    if (this.filterType) {
      params += '&type=' + encodeURIComponent(this.filterType);
    }

    const url = 'crm/opportunities' + params;
    this.dataService.getData(url).subscribe({
      next: (result: any) => {
        console.log('crm/opportunities API result:', result);
        this.opportunities = result?.items ?? result ?? [];
        this.totalRecords = result?.total ?? result?.totalCount ?? result?.total_count ?? this.opportunities.length;
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }

  onFilterChange(): void {
    this.page = 0;
    this.loadOpportunities();
  }

  onPageChange(newPage: number): void {
    this.page = newPage;
    this.loadOpportunities();
  }

  statusClass(status: string): string {
    const map: any = {
      open: 'border border-primary text-primary',
      won: 'border border-success text-success',
      lost: 'border border-danger text-danger',
      abandoned: 'border border-secondary text-secondary'
    };
    return map[status] ?? 'border border-secondary text-secondary';
  }

  openLogInteraction(o: any): void {
    this.logInteractionForId = o.id ?? o.opportunityId ?? o.opportunity_id;
    this.activeEntityId = o.entity_id ?? o.entityId ?? null;
    this.activeCompanyId = o.company_id ?? o.companyId ?? null;
  }

  cancelLogInteraction(): void {
    this.logInteractionForId = null;
    this.activeEntityId = null;
    this.activeCompanyId = null;
  }

  onInteractionSaved(): void {
    this.logInteractionForId = null;
    this.activeEntityId = null;
    this.activeCompanyId = null;
  }

  onRowAction(event: { action: string; row: any }): void {
    if (event.action === 'log') {
      this.openLogInteraction(event.row);
    } else if (event.action === 'view') {
      this.router.navigate(['/crm/opportunities', event.row.id ?? event.row.opportunityId ?? event.row.opportunity_id]);
    }
  }
}
